import { Controller } from "@hotwired/stimulus";
// Connects to data-controller="dialog"
export default class extends Controller {
  static values = {
    dialog: String,
    show: String,
  };
  static targets = ["modal"];

  connect() {
    const showValue = this.showValue === "true";

    if (showValue) {
      this.modalTarget.showModal();
    }
  }

  openDialog = (event) => {
    const button = event.target.closest("button");
    const dialogValue = button.getAttribute("data-dialog-value");
    const dialog = document.getElementById(dialogValue);
    dialog.showModal();
  };
}
